var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 34,
    viewBox: "0 0 61 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6679_177527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5648 26.4379H21.2773V7.56104H46.5648C51.7776 7.56104 56.0033 11.7867 56.0033 16.9995C56.0033 22.2122 51.7776 26.4379 46.5648 26.4379Z",
    fill: "#FF4F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5668 7.56104H43.4883C48.7009 7.56104 52.9267 11.7867 52.9267 16.9995C52.9267 22.2122 48.7009 26.4379 43.4883 26.4379H46.5668C51.7795 26.4379 56.0053 22.2122 56.0053 16.9995C56.0053 11.7867 51.7795 7.56104 46.5668 7.56104Z",
    fill: "#FB2B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2475 19.6342C35.246 19.6342 35.2446 19.6342 35.2431 19.6342C34.6836 19.6372 34.0825 19.6395 33.6291 19.6398V13.5899C33.6291 13.1648 33.2845 12.8203 32.8595 12.8203C32.4343 12.8203 32.0898 13.1649 32.0898 13.5899V20.4038C32.0898 20.7787 32.3599 21.099 32.7295 21.1623C32.7848 21.1719 34.4727 21.1778 35.2519 21.1735C35.6769 21.1711 36.0196 20.8246 36.0172 20.3995C36.0146 19.9758 35.6705 19.6342 35.2475 19.6342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9102 12.8203C37.4851 12.8203 37.1406 13.1649 37.1406 13.5899V20.4095C37.1406 20.8347 37.4852 21.1792 37.9102 21.1792C38.3354 21.1792 38.6798 20.8346 38.6798 20.4095V13.59C38.6798 13.1649 38.3354 12.8203 37.9102 12.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9334 19.6089H48.8557V17.7695H50.7234C51.1485 17.7695 51.493 17.4249 51.493 16.9999C51.493 16.5748 51.1484 16.2302 50.7234 16.2302H48.8557V14.3908H50.9334C51.3585 14.3908 51.703 14.0462 51.703 13.6212C51.703 13.196 51.3584 12.8516 50.9334 12.8516H48.086C47.6609 12.8516 47.3164 13.1961 47.3164 13.6212V20.3786C47.3164 20.8038 47.661 21.1482 48.086 21.1482H50.9334C51.3585 21.1482 51.703 20.8037 51.703 20.3786C51.703 19.9536 51.3585 19.6089 50.9334 19.6089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6624 12.872C45.2594 12.738 44.8234 12.9562 44.6894 13.3597L43.0345 18.3411L41.2977 13.3375C41.1584 12.9359 40.7196 12.7229 40.3183 12.8628C39.9167 13.002 39.7042 13.4406 39.8435 13.8422L42.1771 20.5651C42.308 20.933 42.6571 21.1792 43.0472 21.1792C43.0494 21.1792 43.0515 21.1792 43.0537 21.1791C43.4463 21.1764 43.7952 20.9248 43.9233 20.5477L46.1499 13.845C46.2843 13.4417 46.0658 13.006 45.6624 12.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 29C23.6274 29 29 23.6274 29 17C29 10.3726 23.6274 5 17 5C10.3726 5 5 10.3726 5 17C5 23.6274 10.3726 29 17 29Z",
    fill: "#FF4F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 5C16.4788 5 15.9651 5.03357 15.4609 5.09842C21.3536 5.85628 25.9217 10.9047 25.9217 17C25.9217 23.0953 21.3535 28.1437 15.4609 28.9016C15.9651 28.9664 16.4788 29 17.0003 29C23.6171 29 29.0004 23.6169 29.0004 17C29.0004 10.3832 23.6172 5 17.0003 5Z",
    fill: "#FB2B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8001 18.4235C26.5884 13.5604 23.2852 8.97905 18.422 8.1907C13.5589 7.40235 8.97748 10.7056 8.18914 15.5686C7.4008 20.4317 10.7041 25.0131 15.5672 25.8015C20.4303 26.5898 25.0117 23.2866 25.8001 18.4235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5195 20.5238V13.4761C14.5195 12.7622 15.3317 12.3522 15.9061 12.776L20.6821 16.2998C21.1534 16.6475 21.1534 17.3522 20.6821 17.7L15.9061 21.2238C15.3317 21.6477 14.5195 21.2376 14.5195 20.5238Z",
    fill: "#FF4F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6821 16.3003L15.9061 12.7765C15.3318 12.3527 14.5195 12.7627 14.5195 13.4766V14.0249C16.5227 15.5029 16.5227 18.498 14.5195 19.9759V20.5243C14.5195 21.2381 15.3317 21.6481 15.9061 21.2244L20.6821 17.7005C21.1534 17.3527 21.1534 16.648 20.6821 16.3003Z",
    fill: "#FB2B3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6679_177527",
    x: 0.0999999,
    y: 0.0999999,
    width: 60.8039,
    height: 33.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6679_177527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6679_177527",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/LIVE.5988d9d606f6c56956d6cdff8c9648a6.svg";
export { ForwardRef as ReactComponent };